/* eslint-disable no-console */
/* eslint-disable max-len */
import React from 'react';
import { Grid } from '@mui/material';
import FeedCard from '../Card';

const RepostCard = (props) =>
{
	const { parentData, noAction = false, requestT = 'repost' } = props;

	return (
		<Grid container direction={'column'}>
			<Grid container flexDirection={'column'} spacing={1} m={0}>
				<Grid item xs={12} display={'flex'} flexDirection={'row'} mt={2} borderTop={'1px solid #EFF3F4'} />
				<FeedCard
					item={parentData}
					index={0}
					scheduled={''}
					refreshFeedData={() => {}}
					from={'repost'}
					noAction={noAction}
					requestT={requestT}
				/>
			</Grid>
		</Grid>
	);
};

export default RepostCard;